import {
    LOAD_PRODUCTS,
} from '../actions';

const initialState = {};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_PRODUCTS: {
            const {
                products,
            } = action.payload;

            return products.reduce((object, product) => ({
                ...object,
                [product.slug]: {
                    ...product,
                },
            }), {});
        }
        default: {
            return state;
        }
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./resources/components/shop/reducers/products.js